import { render, staticRenderFns } from "./appointment-card.vue?vue&type=template&id=0e328302"
import script from "./appointment-card.vue?vue&type=script&lang=ts"
export * from "./appointment-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports